import React, { useState } from 'react';
import { connect } from 'react-redux';
import { actions as screeningActions } from '../redux/screeningActions';
import { toastr } from 'react-redux-toastr';
import ScreeningSession from '../components/ScreeningSession/ScreeningSession';
import { NewScreeningDeclarationConfirmation } from '../components/NewScreeningDeclarationConfirmation/NewScreeningDeclarationConfirmation';

const ScreeningContainer = ({
  travellerIndex,
  traveller,
  changeConditionsCovered,
  conditionsCovered,
  region,
  destinations,
  onStartScreening,
  onFinishScreening,
  onUpdateTraveller,
}) => {
  const [hasMigrationError, setHasMigrationError] = useState();

  const clearError = () => {
    setHasMigrationError(undefined);
  };

  const deleteScreening = () => {
    clearError();
    onStartScreening(
      travellerIndex,
      traveller.screening_id,
      region,
      destinations,
      'verisk',
      true,
      traveller.dob,
    );
  };
  const startScreeningSession = () => {
    if (!region && destinations.length === 0) {
      return toastr.error(
        'Trip Details Required',
        'Please select a travel destination or region before adding medical conditions.',
      );
    }
    return Promise.resolve(
      onStartScreening(
        travellerIndex,
        traveller.screening_id,
        region,
        destinations,
        'verisk',
        false,
        traveller.dob,
      ),
    ).catch((e) => {
      setHasMigrationError(e.response?.data?.errors?.[0]?.detail ?? 'errir');
    });
  };

  const finishScreeningSession = () => {
    return Promise.resolve(onFinishScreening()).then((results) => {
      onUpdateTraveller(results);
    });
  };

  return (
    <>
      <NewScreeningDeclarationConfirmation
        show={!!hasMigrationError}
        errorMessage={hasMigrationError}
        onCancel={clearError}
        onConfirm={deleteScreening}
      />
      <ScreeningSession
        travellerIndex={travellerIndex}
        traveller={traveller}
        onStartScreening={startScreeningSession}
        onFinishScreening={finishScreeningSession}
        changeConditionsCovered={changeConditionsCovered}
        conditionsCovered={conditionsCovered}
      />
    </>
  );
};

export default connect(
  null,
  {
    onStartScreening: screeningActions.startScreening,
    onFinishScreening: screeningActions.finishScreening,
  },
)(ScreeningContainer);
